// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* #loading .loadingMsg {\r\n  display: table-cell;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  width: 45px;\r\n  height: 45px;\r\n  background: url('./assets/loading.gif') center center no-repeat;\r\n  background-size: 100px 100px;\r\n}\r\n#loading {\r\n  display: table;\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 9999999\r\n} */\r\n", ""]);
// Exports
module.exports = exports;
